'use client'

import { postErrorLog } from '@/lib/api/main'
import { setAlert } from '@/stores/feature/alert'
import { format } from 'date-fns'
import React from 'react'

interface ErrorState {
  hasError: boolean
}

interface ErrorProps {
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // 에러 상태로 전환
    return { hasError: true }
  }

  async componentDidCatch(error, errorInfo) {
    // 에러 로깅 (필요하면 로그 서버에 전송 가능)
    let errorMessage = 'No error message'
    let evalStackLine = 'No stack line with eval found'

    if (error instanceof Error) {
      errorMessage = error.message || 'No error message'

      const stackLines = error.stack.split('\n')
      const foundLine = stackLines.find((line) => line.includes('eval')).trim()
      evalStackLine = foundLine || 'No stack line with eval found'
    }

    const message = `${errorMessage} - ${evalStackLine}`

    setAlert({
      type: 'error',
      message: `An error occurred: ${error.message}`, // 에러 메시지를 전달
      onConfirm: () => {
        if (typeof window !== 'undefined') {
          window.location.reload()
        }
      },
    })

    // 클라이언트 에러 로깅
    try {
      const result = await postErrorLog({
        type: 'pc-error', // 로그 타입 설정 (예: 'info', 'warn', 'error')
        timestmap: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), // 현재 시간
        location: window.location.pathname, // 현재 URL 경로
        message: message, // 에러 메시지
      })

      if (result) console.log('📌 ~ file: apiError.ts:25 ~ postErrorLog ~ result:', result)
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    if (this.state.hasError) {
      // 에러 발생 시 대체 UI
      return <div>unknown error</div>
    }

    return this.props.children
  }
}

export default ErrorBoundary
